<template>
  <div class="ctrl-button-toggle" :style="{ width: width + 'px' }">
    <a
      @click="toggleIsOpen"
      class="ctrl-button"
      :style="{
        background: disabled
          ? 'rgba(60, 60, 61, 0.1) !important'
          : backgroundColor
          ? backgroundColor
          : '#adadad',
        color: disabled
          ? 'black !important'
          : backgroundColor === 'white'
          ? '#363636'
          : 'white',
        fontSize: fontSize ? fontSize : '14px',
        padding: padding ? padding : '0px 0px 0px 10px',
        height: height ? height : '30px',
        width: dropdownWidth ? dropdownWidth : '285px',
        float: dropdownWidth ? 'left' : '',
        borderColor: disabled
          ? '#3c3c3d !important'
          : backgroundColor === 'white'
          ? '#707070'
          : '#bbb',
        cursor: disabled ? 'not-allowed' : 'pointer',
      }"
    >
      {{ selectedName }}
      <span style="float: right">
        <i data-icon="arrow-down-white" class="icon"></i>
      </span>
    </a>
    <div
      class="ctrl-select-options"
      v-if="isOpen && !disabled"
      :style="{ width: dropdownWidth ? dropdownWidth : width + 'px' }"
    >
      <div>
        <div
          v-if="nullValueText !== undefined"
          role="option"
          @click="selectionChanged(null)"
          class="ctrl-select-option"
        >
          {{ nullValueText }}
        </div>
        <div
          v-for="(obj, index) of sourceList"
          v-bind:key="index"
          role="option"
          @click="selectionChanged(obj)"
          :style="{
            background: obj.backgroundColor ? obj.backgroundColor : 'inherit',
          }"
          class="ctrl-select-option"
        >
          {{ displayPropertyName(obj) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegionDropdown",
  props: {
    sourceList: {
      type: Array,
    },
    keyPropertyName: {
      type: Function,
    },
    displayPropertyName: {
      type: Function,
    },
    localStorageProperty: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
    },
    nullValueText: {
      type: String,
      default: undefined,
    },
    selectedValue: {
      type: String,
      default: null,
    },
    width: {
      type: Number,
      default: 295,
    },
    backgroundColor: {
      type: String,
    },
    fontSize: {
      type: String,
    },
    padding: {
      type: String,
    },
    height: {
      type: String,
    },
    dropdownWidth: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      selectedObject: null,
    };
  },
  mounted() {
    let value = this.selectedValue;
    if (this.localStorageProperty && localStorage[this.localStorageProperty]) {
      value =
        localStorage[this.localStorageProperty] === "null"
          ? null
          : localStorage[this.localStorageProperty];
    }
    if (value && this.sourceList) {
      for (let i = 0; i < this.sourceList.length; i++) {
        if (this.keyPropertyName(this.sourceList[i]) === value) {
          this.selectedObject = this.sourceList[i];
        }
      }
    } else {
      this.selectedObject = this.sourceList[0];
    }
  },
  watch: {
    selectedValue: function(newValue) {
      let value = this.selectedValue;
      if (value && this.sourceList) {
        for (let i = 0; i < this.sourceList.length; i++) {
          if (this.keyPropertyName(this.sourceList[i]) === value) {
            this.selectedObject = this.sourceList[i];
          }
        }
      }
    },
    sourceList: function(newValue) {
      let value = this.selectedValue;
      if (value && this.sourceList) {
        for (let i = 0; i < this.sourceList.length; i++) {
          if (this.keyPropertyName(this.sourceList[i]) === value) {
            this.selectedObject = this.sourceList[i];
          }
        }
      } else {
        this.selectedObject = this.sourceList[0];

        for (let item of this.sourceList) {
          if (item.isSelected) {
            this.selectedObject = item;
          }
        }
        this.selectionChanged(this.selectedObject);
      }
    },
  },
  methods: {
    toggleIsOpen() {
      this.isOpen = !this.isOpen;
    },
    selectionChanged(obj) {
      this.selectedObject = obj;
      this.$emit("selectionChanged", obj ? this.keyPropertyName(obj) : null);
      this.isOpen = false;
    },
    focussed() {
      this.isOpen = true;
    },
    blurred() {
      setTimeout(() => {
        this.isOpen = false;
      }, 200);
    },
  },
  computed: {
    selectedName() {
      return this.selectedObject
        ? this.displayPropertyName(this.selectedObject)
        : this.nullValueText;
    },
  },
};
</script>
<style lang="scss" scoped>
.ctrl-button {
  position: relative;
  margin: 0;
  width: 148px;
  background: $secondary;
  // background: -webkit-linear-gradient(#fff, #eee);
  // background: linear-gradient(#fff, #eee);
  border: 1px solid #bbb;
  // border-radius: 3px;
  color: $white;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  line-height: 27px;
  text-decoration: none;
  width: calc(100% - 10px);
  height: 30px;
  text-align: left;
  padding-left: 10px;

  &.is-active,
  &:active {
    background: rgba(0, 0, 0, 0.05);
    border-color: #aaa;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
    cursor: default;
    z-index: 1;
  }

  .icon {
    background-position: center;
    background-size: 17px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    height: 17px;
    opacity: 0.5;
    padding: 5px 10px;
    vertical-align: top;
    width: 17px;
  }
}
.icon[data-icon="arrow-down"] {
  background-image: url(data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjE4IiB3aWR0aD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTkgMTAuMS00LjktNS0xLjUgMS40IDUgNSAxLjQgMS40IDEuNC0xLjQgNS01LTEuNS0xLjR6Ii8+PC9zdmc+);
}
.ctrl-select-options {
  background: #fff;
  border: 1px solid #bbb;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  font-size: 13px;
  font-weight: 500;
  margin-top: 2px;
  max-height: 260px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 5px 0;
  position: absolute;
  text-align: left;
  white-space: normal;
  max-width: 295px;
  z-index: 6;
}
.ctrl-select-options hr {
  margin: 5px 0;
}
.ctrl-select-options .button {
  display: block;
  margin: 12px 12px 7px;
  width: calc(100% - 24px);
}
.ctrl-select-group-label {
  cursor: default;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 25px 8px 15px;
}
.ctrl-select-option {
  cursor: pointer;
  padding: 9px 25px 8px 15px;
}
.ctrl-select-option:hover {
  background: #f3f3f3;
}
.ctrl-select-option.is-active {
  background: #336bab;
  color: #fff;
}
.ctrl-select-option.is-active:active {
  background: #1a59a1;
}
</style>
